import modalConfirmation from '../../shared/components/modal-response/modal-response.view.html';
import modalQuantityCart from '../modal-quantity-cart/modal-quantity-cart.view.html';
import modalConfirmationCart from '../modal-confirmation/modal-confirmation.view.html';

let inject = [
    '$scope',
    '$state',
    '$rootScope',
    'SharedService',
    'ngAuthSettings',
    'CatalogService',
    '$uibModal',
    '$timeout',
    'CartService',
    'ByFavoritesService',
    'SessionService'
];

class BoxProductsMiniController {
    constructor($scope, $state, $rootScope, SharedService, ngAuthSettings, CatalogService, $uibModal, $timeout, CartService, ByFavoritesService, SessionService) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.$scope = $scope;
        this.CatalogService = CatalogService;
        this.CartService = CartService;
        this.$timeout = $timeout;
        this.ngAuthSettings = ngAuthSettings;
        this.$rootScope = $rootScope;
        this.SharedService = SharedService;
        this.productsInfo = {};
        this.btnPrev = "";
        this.btnNext = "";
        this.classCarousel = "";
        this.ByFavoritesService = ByFavoritesService;
        this.SessionService = SessionService;

        this.dataCart = {};
        this.dataProducs = {};

        this.productItems = {};
    }

    $onInit() {

        if(this.categoryId && this.itemId){
            this.getRelatedCategoryProducts();
        }else if (this.itemId) {
            this.getRelatedProducts();
        } else {
            this.getProducts();
        }
        this.changeId();
    }

    getRelatedCategoryProducts() {
        let userId = '';
        try {
            userId = this.shCtrl.currentUser.userId;
        }catch (e) {}

        this.CatalogService.getRelatedCategoryProducts(this.itemId, userId, 10,this.categoryId).then(response => {
            this.newProducts = response;
            this.initNewProductsCarousel();
        }).catch(error => {});
    }

    changeId() {

        let element = angular.element("#contet-carousel");

        this.classCarousel = element[0].className.split(' ');
        element[0].id = "contet-carousel-" + this.itemName;
        element[0].className = element[0].className + " " + this.itemName;
        angular.element("#des-items-slider-prev")[0].id = this.itemName + "-des-items-slider-prev";
        angular.element("#des-items-slider-next")[0].id = this.itemName + "-des-items-slider-next";
    }

    getProducts() {

        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        this.CatalogService.getProducts(userId, 10, this.itemName).then(response => {
            this.productsInfo.title = this.itemName;
            this.newProducts = response;
            this.newProducts1 = [];
            this.newProducts2 = [];
            if (response.length) {
                response.forEach((valFor, indexFor) => {
                    if (indexFor <= ((response.length - 1) / 2) || response.length < 8) {
                        this.newProducts1.push(valFor);
                    } else {
                        this.newProducts2.push(valFor);
                    }
                });
            }
            // console.log(this.newProducts1);
            this.initNewProductsCarousel();
            // initBrandsCarousel();

            this.loadingRelatedProducts = false;
        }).catch(error => {

        });
    }

    getRelatedProducts() {
        let userId = '';
        try {
            userId = this.shCtrl.currentUser.userId;
        }
        catch (e) {
        }
        this.CatalogService.getRelatedProducts(this.itemId, userId, 10).then(response => {
            this.newProducts = response;
            this.initNewProductsCarousel();
            this.loadingRelatedProducts = false;
        }).catch(error => {

        });
    }

    initNewProductsCarousel() {

        this.$timeout(() => {
            let newItems = $('.' + this.classCarousel[0] + '.' + this.classCarousel[1] + '.' + this.itemName);
            newItems.owlCarousel({
                items: 1,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 2],
                itemsTablet: [768, 2],
                itemsMobile: [479, 1],
                slideSpeed: 400,
                autoPlay: 8000,
                stopOnHover: true,
                navigation: false,
                pagination: false,
                responsive: true,
                mouseDrag: false
            }).data('navigationBtns', ['#' + this.itemName + '-des-items-slider-prev', '#' + this.itemName + '-des-items-slider-next']);
            newItems.each(function () {
                let $this = $(this),
                    owlCarousel = $this.data('owlCarousel'),
                    owlBtns = $this.data('navigationBtns'),
                    prevBtn, nextBtn;

                if (typeof owlCarousel === 'undefined' || typeof owlBtns === 'undefined') {
                    return;
                }

                for (let key in owlBtns) {
                    if (owlBtns[key].indexOf('next') === -1) {
                        prevBtn = $(owlBtns[key]);
                    } else {
                        nextBtn = $(owlBtns[key]);
                    }
                }

                prevBtn.on('click touchstart', function (e) {
                    owlCarousel.prev();
                    e.preventDefault();
                });

                nextBtn.on('click touchstart', function (e) {
                    owlCarousel.next();
                    e.preventDefault();
                });
            });

            $('.add-tooltip').tooltip();
        }, 1000);
    }

    setItemToAddToCart(product) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalQuantityCart,
            controller: 'ModalQuantityCartController',
            controllerAs: 'mdCtrl',
            size: 'sm',
            resolve: {
                product: () => product
            }
        });
        modalInstance.result.then(result => {
            if (result.product.id && result.quantity) {
                let userId = '', cart = null;
                try {
                    userId = this.shCtrl.globals.currentUser.userId;
                } catch (e) {
                }
                try {
                    cart = this.shCtrl.cart;
                } catch (e) {
                }

                let validation  = this.SessionService.validateFactorItems(result.quantity,product);
           
                if(validation.error){
    
                    let options = {
                        title: '',
                        isHtml: true,
                        content: validation.message,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                    return;
                }

                this.CartService.addItemToCart(result.product, result.quantity, null, null, userId, cart).then(response => {
                    if (!response.error) {

                        this.dataCart = {};
                        this.dataProducs = {};
                        this.modalConfirmation(product,result.quantity);
                    } else {
                        if (response.agotado) {
                            product.cantidad = response.itemStock;
                            this.CartService.updateItemsNotAvailable(product, result.quantity, userId);
                        }
                        let options = {
                            title: '',
                            isHtml: true,
                            content: response.message,
                            size: '',
                            showBottonCancel: false,
                            textActionCancel: '',
                            textAction: 'Aceptar'
                        };
                        this.messageResponse(options);
                    }
                }).catch(reason => {
                    let options = {
                        title: '',
                        isHtml: false,
                        content: reason,
                        size: '',
                        showBottonCancel: false,
                        textActionCancel: '',
                        textAction: 'Aceptar'
                    };
                    this.messageResponse(options);
                });
            }
        }).catch(error => {

        });
    }

    updateFavoriteProducts(product) {
        product.isSettingAsFavorite = true;
        let userId = '';
        try {
            userId = this.shCtrl.globals.currentUser.userId;
        }
        catch (e) {
        }
        if (userId) {
            let data = {
                'productId': product.id,
                'userId': userId,
                'setFavorite': !product.isFavorite
            };
            this.CatalogService.updateFavoriteProducts(data).then(response => {


                if (!response.error) {
                    this.ByFavoritesService.getResumeProductsFavorites(this.shCtrl.globals.currentUser.userId).then(favoritesResponse => {
                        this.shCtrl.globals.currentUser.favoriteItems = favoritesResponse;
                        this.SessionService.put('globals', this.shCtrl.globals);

                    });
                }
                product.isFavorite = !product.isFavorite;
                product.isSettingAsFavorite = false;
            }).catch(error => {
                product.isSettingAsFavorite = false;
                let options = {
                    title: '',
                    isHtml: false,
                    content: 'Ha ocurrido un error al actualizar el producto',
                    size: '',
                    showBottonCancel: false,
                    textActionCancel: '',
                    textAction: 'Aceptar'
                };
                this.messageResponse(options);
            });
        }
    }

    messageResponse(options, callAcept, callback, callCancel, callbackCancel) {
        let modalInstance = this.$uibModal.open({
            animation: true,
            template: modalConfirmation,
            controller: 'ModalResponseController',
            controllerAs: 'mdCtrl',
            size: options.size,
            resolve: {
                modalOptions: () => options
            }
        });
        modalInstance.result.then(() => {
            if (callAcept) {
                callback();
            }
        }).catch(reason => {
            if (callCancel) {
                callbackCancel();
            }
        });
    }

    modalConfirmation(products, quantity) {

        this.productAdded = products;
        this.productAdded.image = products.imagesDetail[0].path + products.imagesDetail[0].image;
        this.productAdded.price = products.itemPrice;
        this.productAdded.discount = products.discountValue;
        this.productAdded.ivaValue = products.taxValue;
        this.productAdded.quantity = quantity;
        this.productAdded.total = (products.itemPrice - products.discountValue + products.taxValue) * quantity;

        $('#boxProductsMni').modal('toggle');

        this.$scope.$emit('onUpdateCart', 'modalResponseItems');
    }

}

BoxProductsMiniController.$inject = inject;

export default BoxProductsMiniController;




/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/box-products-mini/box-products-mini.controller.js
 **/